<template>
  <div id="app">
    <el-container>
      <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no">
      <el-main class="input2qiangzhi_buxudong_style">
        <div class="contain">
          <el-tag  closable v-if="ly_zhi"  @close="lingyu_sc_sj()" style="margin-left: 20px">{{ly_zhi.title}}</el-tag>
          <div v-if="$route.path !=='/college/promote' && $route.path !=='/college/novice' && $route.path !=='/college/video' && $route.path !=='/college/category'">
            <div class="main_classification">
              <div style="width: 95%; margin: 0 auto;position: relative">
                <div v-if="aa==1">
                  <i class="el-icon-arrow-down" style="position: absolute;left: 100%;top: 25px;font-size: 16px" @click="xiaoxi(aa=2)"></i>
                  <div class="classification_title">行业分类:</div>
                  <el-row class="search_tops_el_row">
                    <el-col :xs="12" :sm="6" :md="4" v-for="(item1,index) in yingyong_ly.slice(0,12)" :key="index">
                      <a class="a_color" @click="lingyu_sj(item1)"  :title="item1.title"> <div  class="search-tops-title" id="showLabelAndAttrName">{{ item1.title }}
                      </div></a>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div style="width: 95%; margin: 0 auto;position: relative">
                <div v-if="aa==2">
                  <i class="el-icon-arrow-up" style="position: absolute;left: 100%;top: 25px;font-size: 16px" @click="xiaoxi(aa=1)"></i>
                  <div class="classification_title">行业分类:</div>
                  <el-row class="search_tops_el_row">
                    <el-col :xs="12" :sm="6" :md="4" v-for="(item1,index) in yingyong_ly" :key="index">
                      <a class="a_color" @click="lingyu_sj(item1)"  :title="item1.title"> <div  class="search-tops-title" id="showLabelAndAttrName">{{ item1.title }}
                      </div></a>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>

          <div v-if="$route.path =='/college/promote'|| $route.path == '/college/novice'">

            <!--            新手指南-->
            <el-tag  closable v-if="kechengzhi"  @close="kecheng_sc_sj()" style="margin-left: 20px">{{kechengzhi.label}}</el-tag>
            <div class="main_classification" v-if="$route.path == '/college/novice'">
              <div class="classification_title">课程分类:</div>
                <el-row class="search_tops_el_row">
                  <el-col :xs="8" :sm="6" :md="4" v-for="(item1,index1) in kecheng_fl" :key="index1">
                    <a class="a_color" @click="kecheng_sj(item1)"  v-if="item1.nav_id == '2'">
                      <el-dropdown>
                        <div style="width: 100%" class="search-tops-title" id="showLabelAndAttrName">
                          {{ item1.cate_name }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                          <div v-for="item2 in item1.children" :key="item2.id">
                            <a class="a_color" @click="kecheng_sj(item2)">
                              <el-dropdown-item>{{ item2.cate_name }}</el-dropdown-item>
                            </a>
                          </div>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </a>
                  </el-col>
                </el-row>
            </div>
            <!--            专项提升-->
            <div v-else class="main_classification">
              <div class="classification_title">课程分类:</div>
              <el-row class="search_tops_el_row">
                <el-col :xs="8" :sm="6" :md="4" v-for="(item1,index1) in kecheng_fl" :key="index1">
                  <a class="a_color" @click="kecheng_sj(item1)" :title="item1.name" v-if="item1.nav_id == '3'">
                    <el-dropdown>
                      <div  style="width: 100%" class="search-tops-title" id="showLabelAndAttrName">
                        {{ item1.cate_name }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </div>
                      <el-dropdown-menu slot="dropdown" v-for="item2 in item1.children" :key="item2.id">
                        <div v-for="item2 in item1.children" :key="item2.id">
                          <a class="a_color" @click="kecheng_sj(item2)">
                            <el-dropdown-item>{{ item2.cate_name }}</el-dropdown-item>
                          </a>
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </a>
                </el-col>
              </el-row>
            </div>
            <div class="main_num2_el-row">
                <div v-for="(item,index) in pailie" v-bind:key="index" class="best_backgrounds" :class="{active:paixunzhuangtai==index}"
                     @click="paixunshijian(index)">
                  {{ item.name }}
                </div>
            </div>
            <div class="main_num2_quanbu">
              <ul class="uni-search-filter-row-filteres">
                <li class="uni-search-filter-row-filters" style="margin-left: 0px"
                    v-bind:class="{'selected':leixingzhi==''}"
                    v-on:click="leixingshijian('')" >
                  <a>全部</a>
                </li>
                <li class="uni-search-filter-row-filters" v-for="(item2,index) in leixingqingqiu" v-bind:key="index"  v-bind:class="{'selected':leixingzhi==item2.id}" @click="leixingshijian(item2.id)">
                  <a>{{ item2.name }}</a>
                </li>
              </ul>
            </div>
<!--                <el-input class="best_input" v-model="input" placeholder="请输入关键字"-->
<!--       style="margin-top: 29px; width: 135px; position: absolute;" ></el-input>-->
<!--&lt;!&ndash;  &lt;!&ndash;  <input class="best_input" type="text" value="请输入关键字">&ndash;&gt;&ndash;&gt;-->
<!--            <a @click="input_sj(input)">-->
<!--                <img class="sousuo_logo3"-->
<!--                     src="../../../assets/home/sousuo_logo.png" alt=""-->
<!--                     style=" position: relative; top: 36px;left: 318px">-->
<!--            </a>-->
            <div class="bast_all_first">
            <el-input   class="bast_input_first" size="mini"
                        placeholder="请输入关键字" v-model="input">
            </el-input>
            <el-button type="danger" size="mini"
                       class="bast_button_first"
                       @click="input_sj(input)" >搜索
            </el-button>
            </div>
            <el-divider class="main_hrs"></el-divider>
<!--          </div>-->
          </div>
        <div v-if="anniuzhuangtai==0">
          <div v-if="$route.path !=='/college/promote'& $route.path !== '/college/novice'">
            <el-row style="margin-top: 29px">
              <el-col :xs="12" :sm="8" :md="8" style="margin-left: 27px;width: 210px" class="input_qiangzhi" >
                <div v-for="(item,index) in pailie" v-bind:key="index" class="best_background" :class="{active:paixunzhuangtai==index}"
                     @click="paixunshijian(index)">
                  {{ item.name }}
                </div>
              </el-col>
              <el-col :xs="12" :sm="16" :md="16">
<!--                <el-input class="best_input1" v-model="input" placeholder="请输入内容"></el-input>-->
                <div class="button-all">
                <el-input   class="bast_input" size="mini"
                            placeholder="请输入内容" v-model="input"
                            >
                </el-input>
                <el-button type="danger" size="mini"
                           class="bast_button"
                           @click="input_sj(input)" >搜索
                </el-button>
                </div>
                <!--              <input class="best_ input" type="text" value="请输入关键字">-->
<!--                <a @click="input_sj(input)"  class="sousuo_logo2">-->
<!--                  <img  src="../../../assets/home/sousuo_logo.png" alt="">-->
<!--                </a>-->
              </el-col>
            </el-row>
          <el-divider class="main_hr"></el-divider>
          </div>
          <el-row :gutter="35">
            <el-col :xs="24" :sm="12" :md="6" v-for="(item,index) in lightzhi.data" v-bind:key="index">
              <div class="main_middle_background">
                <a v-bind:href="$route.path!=='/college/video'?'#/college/category/'+ item.id:'#/college/video/'+ item.id">
                  <div v-if="$route.path =='/college/video'">
                    <el-image  :src="url_dizhi+'/storage/'+item.pic" fit="cover" style="width: 228px; height: 185px" >
                      <div slot="error" class="image-slot">
                        <img src="../../../assets/wenzhangfengmian.png" alt="" style="height: 185px">
                        <!--                        <i class="el-icon-picture-outline"></i>-->
                      </div>
                    </el-image>
                  </div>
                  <div v-else>
                    <template v-if="item.type==1">
                      <div v-if="item.content != ''" v-html="item.video_str"></div>
                      <div v-else>
                        <img src="../../../assets/wenzhangfengmian.png">
                      </div>
                    </template>
                    <template v-if="item.type!=1" >
                      <div v-if="item.pic==null">
                        <img src="../../../assets/wenzhangfengmian.png" />
                      </div>
                      <div v-else>
                        <img :src="url_dizhi+'/storage/'+item.pic" />
                      </div>
                    </template>

                  </div>
                <div class="main_middle_title">《{{item.title}}》</div>
                <div class="main_middle_time" style="margin-top: -10px">{{item.updated_at.slice(0,10)}}</div>
                </a>
              </div>
            </el-col>
          </el-row>
        </div>
          <el-row v-if="anniuzhuangtai==2">
            <el-row style="margin-top: 29px">
              <el-col :xs="12" :sm="8" :md="8" style="margin-left: 27px;width: 210px" class="input_qiangzhi" >
                <div v-for="(item,index) in pailie" v-bind:key="index" class="best_background" :class="{active:paixunzhuangtai==index}"
                     @click="paixunshijian(index)">
                  {{ item.name }}
                </div>
              </el-col>
              <el-col :xs="12" :sm="16" :md="16">
                <div class="button-all">
                <el-input   class="bast_input" size="mini"
                            placeholder="请输入内容" v-model="input">
                </el-input>
                <el-button type="danger" size="mini "
                           class="bast_button"
                           @click="input_sj(input)" >搜索
                </el-button>
                </div>
<!--                <el-input class="best_input1" v-model="input" placeholder="请输入内容"></el-input>-->
<!--                &lt;!&ndash;              <input class="best_ input" type="text" value="请输入关键字">&ndash;&gt;-->
<!--                <a @click="input_sj(input)"  class="sousuo_logo2">-->
<!--                  <img  src="../../../assets/home/sousuo_logo.png" alt="">-->
<!--                </a>-->
              </el-col>
            </el-row>
            <el-divider class="main_hr"></el-divider>
            <el-row :gutter="15" v-for="(item,index) in normzhi" v-bind:key="index">
              <a v-bind:href="$route.path!=='/college/standard'?'#/college/category/'+ item.id:'#/college/standard/'+ item.id">
              <div class="service-main-backgrounds">
                <el-col :xs="24" :sm="4" :md="4">
                  <el-image class="service-main-pictures" :src="url_dizhi+'/'+item.pic_guobiao" fit="cover" >
                    <div slot="error" class="image-slots">
                      <img src="../../../assets/wenzhangfengmian1.png" alt="" >
                      <!--                        <i class="el-icon-picture-outline"></i>-->
                    </div>
                  </el-image>
                </el-col>
                <el-col :xs="24" :sm="20" :md="20">
                  <div class="service-main-titles">
                    <div class="service-main-title1s">{{item.title}}</div>
                  </div>
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24">
                      <div class="service-main-title2s">所属行业：{{item.category_name}}</div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24">
                      <div class="service-main-title2s">关键词：{{item.keywords}}</div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24">
                 <span  class="service-main-title2s" v-if="item.attachment!==''">
                   附件:
                    <a :href="url_dizhi+'/storage/'+item.attachment[0].url" v-for="(initem,index) in  item.attachment" :key="index">
                    <el-link :underline="false" type="primary">{{initem.name}}</el-link>
                    </a>
                  </span>
                    </el-col>
                  </el-row>
                </el-col>
              </div>
              </a>
            </el-row>
          </el-row>
          <div v-if="anniuzhuangtai==1">
            <el-row style="margin-top: 29px">
              <el-col :xs="12" :sm="8" :md="8" style="margin-left: 27px;width: 210px" class="input_qiangzhi" >
                <div v-for="(item,index) in pailie" v-bind:key="index" class="best_background" :class="{active:paixunzhuangtai==index}"
                     @click="paixunshijian(index)">
                  {{ item.name }}
                </div>
              </el-col>
              <el-col :xs="12" :sm="16" :md="16">
                <div class="button-all">
                <el-input   class="bast_input" size="mini"
                            placeholder="请输入内容" v-model="input">
                </el-input>
                <el-button type="danger" size="mini"
                           class="bast_button"
                           @click="input_sj(input)" >搜索
                </el-button>
                </div>
<!--                <el-input class="best_input1" v-model="input" placeholder="请输入内容"></el-input>-->
<!--                &lt;!&ndash;              <input class="best_ input" type="text" value="请输入关键字">&ndash;&gt;-->
<!--                <a @click="input_sj(input)"  class="sousuo_logo2">-->
<!--                  <img  src="../../../assets/home/sousuo_logo.png" alt="">-->
<!--                </a>-->
              </el-col>
            </el-row>
            <el-divider class="main_hr"></el-divider>

            <el-row :gutter="15" v-for="(item,index) in applicationzhi" v-bind:key="index">
              <a v-bind:href="$route.path!=='/college/programme'?'#/college/category/'+ item.id:'#/college/programme/'+ item.id">
              <div class="service-main-background">
                <el-col :xs="24" :sm="4" :md="4">
                  <el-image class="service-main-picture" :src="url_dizhi+'/storage/'+item.pic" fit="cover" >
                    <div slot="error" class="image-slot">
                      <img src="../../../assets/wenzhangfengmian.png" alt="" >
                      <!--                        <i class="el-icon-picture-outline"></i>-->
                    </div>
                  </el-image>
                </el-col>
                <el-col :xs="24" :sm="20" :md="20">
                  <div class="service-main-title">
                    <div class="service-main-title1">{{item.title}}</div>
                  </div>
                  <el-row>
                    <el-col :xs="24" :sm="12" :md="6">
                      <div class="service-main-title2">浏览次数:<span>{{item.view_count}}</span></div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6">
                      <div class="service-main-title2">下载次数:<span>{{item.download_count}}</span></div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :xs="24" :sm="12" :md="6">
                      <div class="service-main-title2">应用领域:<span>{{item.category_name}}</span></div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6">
                      <div class="service-main-title2">发布时间:<span>{{item.updated_at.slice(0,10)}}</span></div>
                    </el-col>
                  </el-row>
                </el-col>
              </div>
              </a>
            </el-row>
          </div>
          <div data-v-6af373ef="" class="el-pagination is-background" style="margin-left: -20px;margin-top: 40px">
            <span class="el-pagination__total">共 {{ zongshu }} 条</span>
            <el-pagination
                style="float: left;margin-bottom: 150px"
                layout="prev, pager, next"
                @current-change="yedianji"
                :total="yemashu*10">
            </el-pagination>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>

export default {
  name: "category",
  data: function () {

    return {
      searchData: "",
      modules: [],
      searchKey: {},
      input:'',
      zongshu:'',
      yemashu:'',
      yemazhi:1,
      luyou:'',
      filter:{
        article_type:'',
        title:'',
        sort:'date',
        sousuo:'',
      },
      pailie:[
        {zhuangtai:1,name:'最新'},{zhuangtai: 0,name: '最热'}
      ],
      anniuzhuangtai:1,
      article_list: [],
      sousuoshuju:[],
      leixingqingqiu:[],
      leixingzhi:'',
      lightzhi:'',
      normzhi:'',
      applicationzhi:'',

      paixunshangchuan:'',
      paixunzhuangtai:0,
      url_dizhi:'',
      lingyu:'',
      yingyong_ly:'',
      ly_zhi:'',
      kecheng_fl:[],
      kechengzhi:'',
      aa:'1',
    }
  },
  components: {},

  methods: {

    init:function(){
      var t = this
      this.url_dizhi = window.config.api_url
      this.information = this.$store.state.information
      t.input = t.$route.params.id
      if (t.$store.state.categorySearchValue){
        t.searchValue = t.$store.state.categorySearchValue
      }
      if (t.searchValue){
        t.input = t.searchValue
      }
      // console.log(1111111111111)
      if( this.$route.params.article_type ){
        this.filter.article_type = this.$route.params.article_type;
      }
      if (this.$route.params.sousuo){
        this.filter.sousuo= this.$route.params.sousuo;
      }
      if (this.$route.path =='/college/category'||this.$route.path =='/college/novice'||this.$route.path =='/college/promote'||this.$route.path =='/college/video'){
        t.anniuzhuangtai = 0
        if (t.$route.path =='/college/category'){
          t.inputs = t.$route.params.id
          t.quanbu_list()
        }
        if(t.$route.path =='/college/novice') {
          t.inputs = t.$route.params.id
          t.xinshou_list()
        }
        if (t.$route.path =='/college/promote') {
          t.inputs = t.$route.params.id
          t.zhuanxiang_list()
        }
        if(t.$route.path =='/college/video'){
          t.inputs = t.$route.params.id
          t.yicaixiu_list()
        }
      }
      if (this.$route.path =='/college/programme'){
        t.inputs = t.$route.params.id
        t.anniuzhuangtai = 1
        t.fangan_list()
      }
      if (this.$route.path =='/college/standard'){
        t.inputs = t.$route.params.id
        t.anniuzhuangtai = 2
        t.biaozhun_list()
      }
      this.lingyu_list();
      this.wenzhangleixing_api();
      this.kecheng_list();
    },
    //课程分类列表
    kecheng_list(){
      var t = this
      var aid = localStorage.getItem("username");
      var url = window.config.api_url + '/jiangtang/article/category/tree?api_token=' +aid;
      t.axios.get(url).then(res=>{
        t.kecheng_fl = res.data
      })
    },
    kecheng_sj(e){
      var t = this
      t.kechengzhi = e
      if (this.$route.path =='/college/promote'){
        t.zhuanxiang_list()
      }
      if (this.$route.path =='/college/novice'){
        t.xinshou_list()
      }
    },
    kecheng_sc_sj(){
      var t = this
      t.kechengzhi = '';
      if (this.$route.path == '/college/novice'){
        t.xinshou_list();
      }
      if (this.$route.path == '/college/promote'){
        t.zhuanxiang_list();
      }
    },
    input_sj(e){
      var t = this
      t.input = e
      if (this.$route.path =='/college/programme'){
        t.fangan_list()
      }
      if (this.$route.path =='/college/standard'){
        // t.anniuzhuangtai = 2
        t.biaozhun_list()
      }
      if (this.$route.path =='/college/video'){
        // t.anniuzhuangtai = 2
        t.yicaixiu_list()
      }
      if (this.$route.path =='/college/promote'){
        // t.anniuzhuangtai = 2
        t.zhuanxiang_list()
      }
      if (this.$route.path =='/college/novice'){
        // t.anniuzhuangtai = 2
        t.xinshou_list()
      }
    },
    lingyu_sj(e){
      var t = this
      t.ly_zhi = e
      // t.list_data()
      if (this.$route.path =='/college/programme'){
        // t.anniuzhuangtai = 1
        t.fangan_list()
      }
      if (this.$route.path =='/college/standard'){
        // t.anniuzhuangtai = 2
        t.biaozhun_list()
      }
    },
    lingyu_sc_sj(){
      var t = this
      t.ly_zhi = ''
      // t.list_data()
      t.fangan_list()
      t.biaozhun_list()
    },
    lingyu_list(){
      var t = this
      var url = window.config.api_url+'/college/subject'
      t.axios.get(url).then(res=>{
        // console.log(res)
        t.yingyong_ly = res.data
      })
    },
    yedianji(e){
      this.yemazhi = e
      this.init()
    },
    biaozhun_list(){
      var t = this
      var url = window.config.api_url + '/college/norm'
      if (t.yemazhi){
        url = url+'?page='+t.yemazhi
      }
      if (t.paixunzhuangtai==0){
        url = url+'&desc='+'new'
      }
      if (t.paixunzhuangtai==1){
        url = url+'&desc='+'view_count'
      }
      if (t.ly_zhi){
        url += '&category='+t.ly_zhi.id
      }
      if (t.input){
        url += '&keywords='+t.input
      }
      t.axios.get(url).then(res=>{
        t.normzhi = res.data.list.data
          console.log(res.data.list.data)
        t.yemashu = res.data.list.last_page
        t.zongshu = res.data.list.total
      })
    },
     fangan_list(){
      var t = this
      var url = window.config.api_url + '/college/application'
      if (t.yemazhi){
        url = url+'?page='+t.yemazhi
      }
      if (t.paixunzhuangtai==0){
        url = url+'&desc='+'new'
      }
      if (t.paixunzhuangtai==1){
        url = url+'&desc='+'view_count'
      }
      if (t.ly_zhi){
        url += '&category='+t.ly_zhi.id
      }
       if (t.input){
         url += '&keywords='+t.input
       }
      t.axios.get(url).then(res=>{
        t.applicationzhi = res.data.list.data
        t.yemashu = res.data.list.last_page
        t.zongshu = res.data.list.total
      })
    },
    quanbu_list(){
      var t = this
      var url = window.config.api_url + '/college/article/search'
      if (t.yemazhi){
        url = url+'?page='+t.yemazhi
      }
      if (t.paixunzhuangtai==0){
        url = url+'&desc='+'new'
      }
      if (t.paixunzhuangtai==1){
        url = url+'&desc='+'view_count'
      }
      t.axios.get(url).then(res=>{
       t.lightzhi = res.data.list
        t.yemashu = res.data.list.last_page
        t.zongshu = res.data.list.total
      })
    },
    xinshou_list(){
      var t = this
      var url = window.config.api_url + '/college/article/search?nav_id=2'
      if (t.yemazhi){
        url = url+'&page='+t.yemazhi
      }
      if (t.paixunzhuangtai==0){
        url = url+'&sort='+'new'
      }
      if (t.paixunzhuangtai==1){
        url = url+'&sort='+'view_count'
      }
      if (t.kechengzhi){
        url += '&cat_id='+t.kechengzhi.id
      }
      if (t.input){
        url += '&title='+t.input
      }
      if (t.leixingzhi){
        url += '&type='+t.leixingzhi
      }
      t.axios.get(url).then(res=>{
        t.lightzhi = res.data.list
        //todo 视频教程获取到第一帧图片
        res.data.list.data.forEach(item=>{
          item.video_str = t.getVideoImg( item.content );
        });
        t.yemashu = res.data.list.last_page
        t.zongshu = res.data.list.total
      })
    },
    getVideoImg:function( content ){
      var ret = content.match(/(<video.*<\/video>)/);
      if( !ret ){
        return '';
      }
      var video_str = ret[1];
      video_str = video_str.replace('src="/ueditor/upload','src="' + window.config.api_url + '/ueditor/upload')
      return video_str;
    },
    zhuanxiang_list(){
      var t = this
      var url = window.config.api_url + '/college/article/search?nav_id=3'
      if (t.yemazhi){
        url = url+'&page='+t.yemazhi
      }
      if (t.paixunzhuangtai==0){
        url = url+'&sort='+'new'
      }
      if (t.paixunzhuangtai==1){
        url = url+'&sort='+'view_count'
      }
      if (t.kechengzhi){
        url += '&cat_id='+t.kechengzhi.id
      }
      if (t.input){
        url += '&title='+t.input
      }
      if (t.leixingzhi){
        url += '&type='+t.leixingzhi
      }
      t.axios.get(url).then(res=>{
        t.lightzhi = res.data.list
        //todo 视频教程获取到第一帧图片
        res.data.list.data.forEach(item=>{
          item.video_str = t.getVideoImg( item.content );
        })
        t.yemashu = res.data.list.last_page
        t.zongshu = res.data.list.total
        // console.log(t.lightzhi)
      })
    },
    yicaixiu_list(){
      var t = this
      var url = window.config.api_url + '/college/video?paginate=20'
      if (t.yemazhi){
        url = url+'&page='+t.yemazhi
      }
      if (t.paixunzhuangtai==0){
        url = url+'&desc='+'new'
      }
      if (t.paixunzhuangtai==1){
        url = url+'&desc='+'view_count'
      }
      if (t.input){
        url += '&keywords='+t.input
      }
      t.axios.get(url).then(res=>{
        t.lightzhi = res.data.list
        t.yemashu = res.data.list.last_page
        t.zongshu = res.data.list.total
        console.log(t.lightzhi)
      })
    },
    search: function () {

      var that = this;
      var url = window.config.api_url + '/college/article/search';
      var params = [];
      if( this.filter.article_type ){
        params.push('article_type=' + this.filter.article_type);
      }
      this.filter.title = this.filter.title.replace(/^(\s+)|(\s+)$/,'');
      if( this.filter.title ){
        params.push('title=' + this.filter.title);
      }
      if (this.leixingzhi){
        params.push('type=' + this.leixingzhi);
      }
      if (this.paixunshangchuan=='new'){
        params.push('sort=' + this.paixunshangchuan);
      }
      if (this.paixunshangchuan=='hot'){
        params.push('sort=' + this.paixunshangchuan);
      }
      if( params.length>0 ){
        url += '?' + params.join('&');
      }

      this.axios.get( url ).then(function (res) {
        // console.log(res)
        that.article_list = res.data;
        // console.log( that.article_list,989999999999 )
      });
    },
    lights(){
      var t = this
      var url = window.config.api_url+'college/article/search'
      t.axios.get(url).then(res=>{
        t.lightzhi = res.data.list.data
        // console.log(res)
      })
    },

    application(){
      var t = this
      var url = window.config.api_url+'/college/application'
      t.axios.get(url).then(res=>{
        t.applicationzhi = res.data.list.data
        t.lingyu = res.data.category
      })
    },
    search_by_type:function( article_type ){

      this.filter.article_type = article_type;
      this.search();
    },
    sousuozhi(){
      var that = this
      if (this.filter.sousuo){
        this.axios
            .get(window.config.api_url+'/college/article/search'+'?'+'title='+this.filter.sousuo)
            .then(function( res ){
              that.sousuoshuju = res.data.data
              // console.log( that.sousuoshuju,989999999999 )
            });
      }
    },
    qiehuanshijian(eve){
      this.anniuzhuangtai = eve
    },
    wenzhangleixing_api(){
      var t = this
      this.axios
          .get(window.config.api_url+'/college/article/type')
          .then(function( res ){
            t.leixingqingqiu = res.data
            // console.log(  t.leixingqingqiu )
          });
    },
    leixingshijian(eve){
      // console.log(999999)
      this.leixingzhi= eve
      if (this.$route.path =='/college/novice'){
        // t.anniuzhuangtai = 1
        this.xinshou_list()
      }
      if (this.$route.path =='/college/promote'){
        // t.anniuzhuangtai = 2
        this.zhuanxiang_list()
      }
      // console.log(eve)
      this.search()
    },
    paixunshijian(eve){
      var  t = this
      t.paixunzhuangtai = eve
      this.init()
    },
    mounted() {
      document.onkeydown = function (event) {  // 回车实现点击功能
        var e = event || window.event;
        if (e && e.keywords == 13) {
          ("#btn").click();
        }
      };
    },
    watch: { // watch实时监控输入内容,如果没有任何内容,则显示整个列表
      searchData(current) {
        let that = this;
        if(current == ''){
          that.list = that.modules
        }
      }
    },
    methods:{
      xiaoxi(aa){
        console.log(aa)
      },
      search() {
        let that = this;
        if (that.searchData === '' || typeof(that.searchData)=="undefined")
        {
          that.list=that.modules;
        }else{
          that.list=[]
          that.modules.map(function(item) {
            console.log(typeof item.id);
            if (item.name.search(that.searchData) != -1) { // 筛选条件
              that.list.push(item);
            }
          });
        }
      },
      getData(){
        let that = this;
        // http://jsonplaceholder.typicode.com/users
        this.$http.get('/users').then(function(res){ // 获取数据 利用代理服务器获取
          console.log(res)
          if(res.status == 200){
            that.modules = res.data;
            console.log(res.data)
            that.list=that.modules;
          }else{
            alert('服务异常！');
          }
        },
        //   function(res){
        //   // alert(res.status);
        // }
          );
      },
    }
  },
  created: function () {
    this.init()
  },
  watch:{
    '$store.state.categorySearchValue'() {
      if(this.$store.state.information!==this.searchValue){
        this.init()
      }
    },
    '$route'() {
      if (this.$route.params.id) {

        this.init()
      }
      else {

        this.init()
      }
    }
  }

}
</script>
<style>

.input2qiangzhi_buxudong_style .el-input__inner{
  /*margin-left: -10px!important;*/
  /*width: 110px!important;*/
  height: 27px!important;
  float: left!important;
  color: #666666!important;
  /*margin-left: 271px!important;*/
  /*margin-top: -42px!important;*/
  padding-left: 11px!important;
  border: 0px!important;
  /*background: #E1E1E1!important;*/
  border-radius: 5px!important;
}


</style>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
@head_text : Source Han Sans CN;
@font-face {

}
//@import "../../../assets/css/home";
@import "../../../assets/css/home_category";
.hallo{
  font-family: Source Han Sans CN;
}
@media screen and (min-width:950px) {
  .background-title1_yingyong{
    margin-top: 30px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    float: left;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
  .background-title1_liulan{
    margin-top: 30px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-left: 109px;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
  .background-title1_xiazai{
    margin-top: 30px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-left: 109px;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
  .background-title1_time{
    margin-top: 70px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
}

@media screen and (min-width:700px) and (max-width:950px){
  .background-title1_yingyong{
    margin-top: 30px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    float: left;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
  .background-title1_liulan{
    margin-top: 30px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-left: 109px;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
  .background-title1_xiazai{
    margin-top: 70px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
  .background-title1_time{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-top: -25px;
    margin-left: 222px;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
}
@media screen and (max-width:700px){
  .el-main .contain .main_classification .classification_title{
    margin-left: 8px;
  }
  .el-main .contain .main_classification .uni-search-filter-row-filters .uni-search-filter-row-filter{
    margin-left: 5px;
  }
  .el-main .contain .main_classification .selected{
    width: 70px;
  }
  .el-main .contain .best_background{
    margin-left: 21px;
  }
  .el-main .contain .best_input{
    margin-left: 31px;
  }
  .background-title1_yingyong{
    margin-top: 30px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    float: left;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
  .background-title1_liulan{
    margin-top: 30px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-left: 59px;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
  .background-title1_xiazai{
    margin-top: 70px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
  .background-title1_time{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-top: -25px;
    margin-left: 163px;
    span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4E6EF2;
      margin-left: 20px;
    }
  }
}


.bast_input{
  /*margin-top: 2px;*/
  border: 1px solid #c60000;
  border-radius: 5px;
  width:135px;
  margin-left: 100px

}
.bast_button{
  position: relative;
  top: -10px;
  left: -10px;
  height: 30px;

}

  .button-all{
    width:400px;
    .bast_input{
      margin-top: 2px;
      border: 1px solid #c60000;
      border-radius: 5px;
      width:135px;
    }
    .bast_button{
      position: relative;
      top:-10px;
      left:-5px;
      height: 30px;
      height: 30px;
      width: 60px;
    }
  }
  .bast_all_first{
    width:400px;
    .bast_input_first{
      border: 1px solid #c60000;
      border-radius: 5px;
      width:135px;
      position: relative;
      top: -30px;
      left: 650px;
    }
    .bast_button_first{
      position: relative;
      left:645px;
      top:-40px;
      height: 30px;
      width: 60px;


    }
  }
</style>
<style lang="less" scoped>
@font-face {

}
</style>
<style>
  video{
    height: 185px;
    width: 228px;
  }
</style>
